module.exports = __webpack_public_path__ + "static/directoryFallback@2x-9bd46dd7e320b926f101aa3d0e24e251.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/collaboration/directoryFallback@2x.jpg
// module id = 2577
// module chunks = 168707334958949